var eqNull = require('./eqNull')
var isNumber = require('./isNumber')
var toNumberString = require('./toNumberString')

function toValueString (obj) {
  if (isNumber(obj)) {
    return toNumberString(obj)
  }
  return '' + (eqNull(obj) ? '' : obj)
}

module.exports = toValueString



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/toValueString.js
// module id = 6
// module chunks = 98